import { LocalStorageUtils } from './LocalStorageUtils';
import { registedDomains } from './RegisteredDomains';
import { isAllowed } from '../cmp/utils';
import translations from '../resources/translations/translations';

const DIDOMI_TOKEN_COOKIE_NAME = 'euconsent-v2';
const DIDOMI_TOKEN_COOKIE_NAME_QA = 'euconsent';
const USER_STATUS_ITEM_NAME = 'didomi_user_status';
export const EDO_VENDOR = 'eDo';
export const TECHNICAL_PURPOSE = 'technical';
export const DEFAULT_DOMAIN = 'sdk.privacy-center.org';

export const Websites = Object.freeze({
  EDREAMS: 'ED',
  OPODO: 'OP',
  GOVOYAGES: 'GO',
  TRAVELLINK: 'TR',
});

export const DidomiUtils = {
  consentChangeCallbacks: new Map(),
  onChangeCallback: () => {
    while (global.CMPCallbackList && global.CMPCallbackList.length > 0) {
      const cb = global.CMPCallbackList.pop();
      cb({ isAllowed });
    }
  },
  isConsentCollectedByType(status, type) {
    let isCollectedByType = false;
    if (status && status[type] && status[type].consent) {
      const hasDisabled = status[type].consent.disabled
        ? status[type].consent.disabled
        : [];
      const hasEnabled = status[type].consent.enabled
        ? status[type].consent.enabled
        : [];
      isCollectedByType = hasDisabled.length > 0 || hasEnabled.length > 0;
    }
    return isCollectedByType;
  },
  isConsentCollected(status) {
    const hasPurposes = this.isConsentCollectedByType(status, 'purposes');
    const hasVendors = this.isConsentCollectedByType(status, 'vendors');
    return hasPurposes || hasVendors;
  },
  getInfo() {
    return this.isDebugMode()
      ? require('../resources/qa/storageConsentInfoStrict')
      : require('../resources/prod/storageConsentInfoStrict');
  },
  getValuesInPropertiesFromKey(storage, key) {
    let vendor = '';
    let purposes = [];
    const hardCodedValues = this.getInfo();
    if (hardCodedValues) {
      const item = hardCodedValues[storage][key];
      if (item) {
        vendor = item.vendor;
        purposes = item.purposes;
      }
    }
    return { vendor, purposes };
  },
  isPurposesAllowed(purposes, status) {
    const disabledList =
      status && status.purposes && status.purposes.consent
        ? status.purposes.consent.disabled
        : [];
    return purposes.every(purpose => disabledList.indexOf(purpose) === -1);
  },
  isVendorAllowed(vendor, status) {
    const disabledList =
      status && status.vendors && status.vendors.consent
        ? status.vendors.consent.disabled
        : [];
    return disabledList.indexOf(vendor) === -1;
  },
  getDidomiTokenCookieName() {
    return this.isDebugMode()
      ? DIDOMI_TOKEN_COOKIE_NAME_QA
      : DIDOMI_TOKEN_COOKIE_NAME;
  },
  isDidomiTokenCookieSet() {
    const cookieName = this.getDidomiTokenCookieName();
    return window.document.cookie.indexOf(cookieName) !== -1;
  },
  getUserStatusFromDidomi() {
    return window.Didomi?.getUserStatus?.();
  },
  saveUserStatus() {
    const status = this.getUserStatusFromDidomi();
    LocalStorageUtils.erase(USER_STATUS_ITEM_NAME);
    LocalStorageUtils.create(USER_STATUS_ITEM_NAME, status);
  },
  getUserStatus() {
    const userStatusItem = LocalStorageUtils.read(USER_STATUS_ITEM_NAME);
    let status;

    if (!userStatusItem || !this.isDidomiTokenCookieSet()) {
      status = this.getUserStatusFromDidomi();
    } else {
      status = userStatusItem;
    }
    return status;
  },
  loadDidomiScript() {
    const isWindowObjDefined = typeof window !== 'undefined';
    if (!isWindowObjDefined) return;

    window.gdprAppliesGlobally = true;
    return new Promise(res => {
      (function() {
        function i(e) {
          if (!window.frames[e]) {
            if (document.body && document.body.firstChild) {
              var t = document.body;
              var n = document.createElement('iframe');
              n.style.display = 'none';
              n.name = e;
              n.title = e;
              t.insertBefore(n, t.firstChild);
            } else {
              setTimeout(function() {
                i(e);
              }, 5);
            }
          }
        }

        function e(n, o, r, f, s) {
          function e(e, t, n, i) {
            if (typeof n !== 'function') {
              return;
            }
            if (!window[o]) {
              window[o] = [];
            }
            var a = false;
            if (s) {
              a = s(e, i, n);
            }
            if (!a) {
              window[o].push({
                command: e,
                version: t,
                callback: n,
                parameter: i,
              });
            }
          }
          e.stub = true;
          e.stubVersion = 2;

          function t(i) {
            if (!window[n] || window[n].stub !== true) {
              return;
            }
            if (!i.data) {
              return;
            }
            var a = typeof i.data === 'string';
            var e;
            try {
              e = a ? JSON.parse(i.data) : i.data;
            } catch (t) {
              return;
            }
            if (e[r]) {
              var o = e[r];
              window[n](
                o.command,
                o.version,
                function(e, t) {
                  var n = {};
                  n[f] = {
                    returnValue: e,
                    success: t,
                    callId: o.callId,
                  };
                  if (i.source) {
                    i.source.postMessage(a ? JSON.stringify(n) : n, '*');
                  }
                },
                o.parameter
              );
            }
          }
          if (typeof window[n] !== 'function') {
            window[n] = e;
            if (window.addEventListener) {
              window.addEventListener('message', t, false);
            } else {
              window.attachEvent('onmessage', t);
            }
          }
        }
        e('__tcfapi', '__tcfapiBuffer', '__tcfapiCall', '__tcfapiReturn');
        i('__tcfapiLocator');
      })();

      (function() {
        (function(e) {
          var r = document.createElement('link');
          r.rel = 'preconnect';
          r.as = 'script';
          var t = document.createElement('link');
          t.rel = 'dns-prefetch';
          t.as = 'script';
          var n = document.createElement('script');
          n.onload = function() {
            res();
          };
          n.id = 'spcloader';
          n.type = 'text/javascript';
          n['async'] = true;
          n.charset = 'utf-8';
          var o =
            DidomiUtils.getDidomiUrl() +
            e +
            '/loader.js?target=' +
            document.location.hostname;
          if (window.didomiConfig && window.didomiConfig.user) {
            var i = window.didomiConfig.user;
            var a = i.country;
            var c = i.region;
            if (a) {
              o = o + '&country=' + a;
              if (c) {
                o = o + '&region=' + c;
              }
            }
          }
          r.href = DidomiUtils.getDidomiUrl();
          t.href = DidomiUtils.getDidomiUrl();
          n.src = o;
          var d = document.getElementsByTagName('script')[0];
          if (d) {
            d.parentNode.insertBefore(r, d);
            d.parentNode.insertBefore(t, d);
            d.parentNode.insertBefore(n, d);
          }
        })('c81d422d-223b-4c8a-8b2e-099d6fa3acb9');
      })();
    });
  },

  loadDidomi() {
    if (global.initPromise) return global.initPromise;
    else {
      global.initPromise = DidomiUtils.loadDidomiScript();
      return global.initPromise;
    }
  },

  loadDidomiMoroccoTestScript() {
    const isWindowObjDefined = typeof window !== 'undefined';
    if (!isWindowObjDefined) return;

    window.gdprAppliesGlobally = true;
    return new Promise(res => {
      (function() {
        (function(e) {
          var r = document.createElement('link');
          r.rel = 'preconnect';
          r.as = 'script';
          var t = document.createElement('link');
          t.rel = 'dns-prefetch';
          t.as = 'script';
          var n = document.createElement('script');
          n.id = 'spcloader';
          n.type = 'text/javascript';
          n['async'] = true;
          n.charset = 'utf-8';
          var o =
            'https://privacy.edreams.ma/' +
            e +
            '/loader.js?target=' +
            document.location.hostname;
          if (window.didomiConfig && window.didomiConfig.user) {
            var i = window.didomiConfig.user;
            var a = i.country;
            var c = i.region;
            if (a) {
              o = o + '&country=' + a;
              if (c) {
                o = o + '&region=' + c;
              }
            }
          }
          r.href = 'https://privacy.edreams.ma/';
          t.href = 'https://privacy.edreams.ma/';
          n.src = o;
          var d = document.getElementsByTagName('script')[0];
          d.parentNode.insertBefore(r, d);
          d.parentNode.insertBefore(t, d);
          d.parentNode.insertBefore(n, d);
        })('c81d422d-223b-4c8a-8b2e-099d6fa3acb9');
      })();
      res();
    });
  },

  loadDidomiMoroccoTest() {
    if (global.initPromise) return global.initPromise;
    else {
      global.initPromise = DidomiUtils.loadDidomiMoroccoTestScript();
      return global.initPromise;
    }
  },

  setDidomiEvents(website, locale) {
    const isWindowObjDefined = typeof window !== 'undefined';
    if (!isWindowObjDefined) {
      return;
    }
    window.didomiEventListeners = window.didomiEventListeners || [];
    window.didomiEventListeners.push({
      event: 'consent.changed',
      listener: () => {
        // consent configuration has changed because the user has interacted with the popup and agreed/disagreed/configured&saved
        DidomiUtils.saveUserStatus();
        DidomiUtils.onChangeCallback();
        for (const [, cb] of this.consentChangeCallbacks) {
          cb();
        }
      },
    });
    window.didomiOnReady = window.didomiOnReady || [];
    window.didomiOnReady.push(() => {
      if (DidomiUtils.isDidomiTokenCookieSet()) {
        // consent is loaded but not shown as it was previously agreed/disagreed/configured&saved
        DidomiUtils.onChangeCallback();
      }
    });
    window.didomiOnReady.push(DidomiUtils.checkWebViewConsent);
    if (
      website === Websites.EDREAMS &&
      (locale === 'en-US' || locale === 'es-US')
    ) {
      window.didomiOnReady.push(DidomiUtils.showInformativeBanner);
    }
  },
  showInformativeBanner(didomi = window.Didomi) {
    if (didomi.shouldConsentBeCollected()) {
      didomi.setUserAgreeToAll();
      didomi.notice.show();
    }
  },
  checkWebViewConsent(didomi = window.Didomi) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('didomiConfig.notice.enable') === 'false') {
      didomi.setUserDisagreeToAll();
      didomi.notice.hide();
    }
  },
  getTranslationFile(website, locale) {
    return translations[`${website}_${locale}`];
  },
  getDidomiUrl() {
    if (!window?.didomiConfig?.sdkPath) {
      return `https://${DEFAULT_DOMAIN}/`;
    }
    return window.didomiConfig.sdkPath;
  },
  getDidomiDomain() {
    try {
      const hostname = window?.location?.hostname || '';
      const replacedHostname = hostname.replace(
        /([a-zA-Z0-9-.]+\.)?(edreams|opodo|travellink|govoyages)\.([a-zA-Z.]+)/,
        'privacy.$2.$3'
      );
      return registedDomains.includes(replacedHostname)
        ? replacedHostname
        : null;
    } catch {
      return null;
    }
  },
  setDidomiConfig(website, locale) {
    const translation = this.getTranslationFile(website, locale);
    const language = locale ? locale.substring(0, 2) : 'en';

    const isWindowObjDefined = typeof window !== 'undefined';

    const isEnabled =
      isWindowObjDefined && window?.didomiConfig?.notice?.enable !== undefined
        ? window.didomiConfig.notice.enable
        : true;

    if (!isWindowObjDefined) {
      return;
    }
    const customDomain = this.getDidomiDomain();
    window.didomiConfig = {
      ...window.didomiConfig,
      ...(customDomain && {
        sdkPath: `https://${customDomain}/`,
        apiPath: `https://${customDomain}/api`,
      }),
      app: {
        ...window.didomiConfig?.app,
        privacyPolicyURL: translation.cookiesPolicyLink,
      },
      languages: {
        ...window.didomiConfig?.languages,
        enabled: [language],
        default: language,
      },
      notice: {
        ...window.didomiConfig?.notice,
        enable: isEnabled,
      },
      user: {
        externalConsent: {
          enabled: true,
        },
      },
    };
    if (website === Websites.TRAVELLINK) {
      window.didomiConfig.user = {
        bots: {
          consentRequired: false,
          extraUserAgents: [
            'Mozilla\\/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit\\/537.36 (KHTML, like Gecko) Chrome\\/62.0.3202.94 Safari\\/537.36 Agnostik\\/1.0',
            'Mozilla\\/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit\\/537.36 (KHTML, like Gecko) Chrome\\/103.0.0.0 Safari\\/537.36 Agnostik\\/1.0',
            'Mozilla\\/5.0 (X11; CrOS x86_64 14092.57.0) AppleWebKit\\/537.36 (KHTML, like Gecko) Chrome\\/93.0.4577.85 Safari\\/537.36',
          ],
        },
      };
    }
  },
  setCallback(cb) {
    global.CMPCallbackList = global.CMPCallbackList || [];
    global.CMPCallbackList.push(cb);
  },
  isDebugMode() {
    return global.isCMPDebugMode ? global.isCMPDebugMode : false;
  },
  isAlreadyInitialized() {
    return typeof window !== 'undefined' ? !!window.Didomi : false;
  },
};
